var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.numeral>3)?[_c('Home')]:[_c('Mobile')]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }